import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTerminal } from "@/lib/terminal";
import { EXPLORER, eth } from "@/lib/format";

export default function HistoryPage() {
  const { api } = useTerminal();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    const load = () => api("get", "/trades").then(setRows).catch(() => setRows([]));
    load();
    const t = setInterval(load, 8000);
    return () => clearInterval(t);
  }, [api]);
  return (
    <div className="rounded-md border border-[#222634] bg-[#101216] overflow-hidden" data-testid="history-table">
      <h1 className="px-3 h-11 flex items-center text-lg font-bold tracking-tight border-b border-[#222634]">İşlem Geçmişi</h1>
      <div className="overflow-x-auto">
        <table className="w-full text-xs font-mono">
          <thead className="text-slate-500"><tr className="border-b border-[#222634]"><th className="text-left px-3 py-2">Zaman</th><th className="text-left px-2">Token</th><th className="text-left px-2">Tür</th><th className="text-right px-2">ETH</th><th className="text-left px-2">Kaynak</th><th className="text-left px-2">Durum</th><th className="text-left px-3">Tx</th></tr></thead>
          <tbody>
            {(rows || []).map((r) => (
              <tr key={r.id} className="border-b border-[#222634]/50 hover:bg-[#161920]" data-testid={`history-row-${r.id}`}>
                <td className="px-3 py-2 text-slate-400">{new Date(r.created_at).toLocaleString("tr-TR")}</td>
                <td className="px-2"><Link to={`/token/${r.token}`} className="font-sans font-semibold hover:text-[#00E676]">{r.symbol}</Link></td>
                <td className={`px-2 font-semibold ${r.side === "buy" ? "text-[#00E676]" : r.side === "claim" ? "text-[#FFD700]" : "text-[#FF5252]"}`}>{{ buy: "AL", sell: "SAT", claim: "CLAIM" }[r.side]}</td>
                <td className="px-2 text-right">{eth(r.eth)}</td>
                <td className="px-2">{r.source === "bot" ? <span className="text-[#00F0FF]">BOT</span> : "Manuel"}{r.wallet_label && <span className="text-slate-500"> · {r.wallet_label}</span>}</td>
                <td className="px-2">{r.status === "ok" ? <span className="text-[#00E676]">OK</span> : <span className="text-[#FF5252]" title={r.error}>HATA</span>}</td>
                <td className="px-3">{r.tx ? <a href={`${EXPLORER}/tx/${r.tx}`} target="_blank" rel="noreferrer" className="text-slate-400 hover:text-slate-100">{r.tx.slice(0, 10)}…</a> : <span className="text-slate-600 truncate max-w-[220px] inline-block align-bottom">{r.error}</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {rows && rows.length === 0 && <p className="p-6 text-sm text-slate-500">Henüz işlem yok</p>}
      </div>
    </div>
  );
}
